import CheckboxUncontrolled from "../../../components/CheckboxUncontrolled";

const TdDayVal2 = ({ value, status }) => {
  return (
    <td className="center">
      {status === 1 || status === 2 ? (
        <CheckboxUncontrolled
          name="day[]"
          value={value}
          checked={true}
          disabled={false}
        />
      ) : (
        <span />
      )}
    </td>
  );
};

export default TdDayVal2;
